// 设备适配
import Device from 'utils/device'
import CreateNode from 'utils/createNode'
import mobile from './mobile'
import pc from './pc'

if (Device.isMobile) {
  // 设置手机默认样式
  CreateNode(
    'style',
    '#app{width:750px;margin:auto;position:relative}',
    document.head
  )
  // 移动端的适配
  mobile(750)
} else {
  // pc端的适配
  pc(1920)
}